import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Content, Sider } = Layout;

const graphs = [
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Evolución en el tiempo",
    text: `Desde 2015, ha crecido el número de niñas y niños que viven en familias sin apoyos para el cuidado. En 2015, un 14% se encontraba en esta situación; en 2017, un 12%, en 2022 la cifra alcanzó su punto más alto con un 18% y en la última medición disminuyó a un 16%. Este aumento destaca la necesidad de abordar el problema desde políticas públicas, considerando el bienestar infantil y el desarrollo personal y laboral de madres y cuidadores.`,
    link: "https://public.flourish.studio/visualisation/20879688/embed",
  },
  {
    id: "graph2",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `De acuerdo a la encuesta Casen, no hay diferencias entre la proporción de niñas y niños que viven en familias que declaran vivir sin apoyo en su cuidado.`,
    link: "https://public.flourish.studio/visualisation/20879733/embed",
  },
  {
    id: "graph3",
    title: "Análisis por edad",
    menuTitle: "\u2022 Edad",
    text: `La primera infancia es intensiva en términos de cuidados, debido a la alta dependencia de niñas y niños. No obstante, en la infancia media y adolescencia, los cuidados siguen siendo esenciales aunque cambian en su naturaleza. Según la encuesta Casen, no se observan diferencias significativas entre los primeros dos grupos etarios en la última medición de 2024. Entre las y los adolescentes, no obstante, hay una mayor proporción de falta de apoyo en el cuidado. Esta tendencia se repite en los años anteriores, a excepción del 2022, donde los tres grupos presentaban la misma proporción.`,
    link: "https://public.flourish.studio/visualisation/20879775/embed",
  },
  {
    id: "graph4",
    title: "Análisis por nacionalidad",
    menuTitle: "\u2022 Nacionalidad",
    text: `Las niñas y niños nacidos fuera de Chile tienen más probabilidades de vivir en familias sin redes de apoyo para el cuidado que quienes nacieron en el país. Esta tendencia se ha mantenido constante a lo largo del tiempo. En 2024, un 15% de las niñas y niños nacidos en Chile vive en familias sin apoyo en el cuidado, mientras que esta cifra aumenta a un 22% entre quienes nacieron fuera de Chile.  Esta diferencia evidencia la necesidad de entregar mayores apoyos a  las familias migrantes, para asegurar que niñas y niños gocen de una calidad de vida similar a la de sus pares chilenos.`,
    link: "https://public.flourish.studio/visualisation/20879793/embed",
  },
  {
    id: "graph5",
    title: "Análisis por pueblo originario",
    menuTitle: "\u2022 Pueblo originario",
    text: `En Chile, no hay diferencias significativas entre las niñas y niños que se identifican con pueblos indígenas y aquellos que no lo hacen en cuanto al  apoyo que tienen sus familias para su cuidado.`,
    link: "https://public.flourish.studio/visualisation/20879808/embed",
  },
  {
    id: "graph6",
    title: "Análisis por quintil de ingresos",
    menuTitle: "\u2022 Quintil de ingresos",
    text: `En Chile, hay diferencias relevantes en la percepción de apoyo en el cuidado según el ingreso del hogar. En el primer quintil, es decir, el de menores ingresos, un 18% de las niñas y niños viven en hogares que declaran no tener apoyo, mientras que en el quinto quintil, la cifra disminuye a un 11%. Esta brecha se observa en todos los años de medición. Las redes de apoyo, por tanto, reflejan profundas desigualdades socioeconómicas.`,
    link: "https://public.flourish.studio/visualisation/20879812/embed",
  },
  {
    id: "graph7",
    title: "Análisis por zona de residencia",
    menuTitle: "\u2022 Zona",
    text: `En la última medición, no se observan diferencias estadísticamente significativas entre la zona urbana y rural. En 2022, en cambio, en las zonas urbanas había una mayor proporción de niñas y niños en familias que no tenían apoyo en el cuidado.`,
    link: "https://public.flourish.studio/visualisation/20879801/embed",
  },
  {
    id: "graph8",
    title: "Análisis por región",
    menuTitle: "\u2022 Región",
    text: `En 2024, las regiones que tienen una mayor proporción de falta de apoyo en el cuidado corresponden a Arica y Parinacota (24%) y O’Higgins (19%). Las que presentan una menor proporción, por otro lado, son el Maule (12%) y la región del Biobío (11%). 

En la mayoría de las regiones se mantuvo igual o disminuyó la proporción de niñas y niños en familias que no cuentan con apoyo en el cuidado. Sin embargo, la Región de Arica y Parinacota presentó un alza, de 18% a 24%.`,
    link: "https://public.flourish.studio/visualisation/20879715/embed",
  }
];

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;

